import Model from '@/app/Model'

export class Tokens extends Model {
	static fields () {
		return {
			accessToken: null,
			refreshToken: null,
			idToken: null
		}
	}
}

export function createTokens (data) {
	return Object.freeze(new Tokens(data))
}
